export { Login } from './components';
export const siteName = 'meritz';
export const autoLogin = true;
export const saveId = true;
